/**
 * Local Delivery - Google Maps Places Autocomplete for recipient address.
 * Loads the Maps script dynamically when an API key is provided via config.
 */
(function () {
  'use strict';

  var LOG = '[wf-ld-ac]';
  var scriptLoaded = false;

  function loadScript(apiKey) {
    if (scriptLoaded || !apiKey) return;
    scriptLoaded = true;
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' +
      encodeURIComponent(apiKey) + '&libraries=places&loading=async&v=weekly';
    s.async = true;
    document.head.appendChild(s);
  }

  function normalizeHooks(hooks) {
    if (!hooks || typeof hooks !== 'object') {
      return {
        onPostalFilled: null,
        onPlaceApplyStart: null,
        onPlaceApplyEnd: null,
        onPostalPlaceApplyStart: null,
        onPostalPlaceApplyEnd: null,
      };
    }
    return {
      onPostalFilled: typeof hooks.onPostalFilled === 'function' ? hooks.onPostalFilled : null,
      onPlaceApplyStart: typeof hooks.onPlaceApplyStart === 'function' ? hooks.onPlaceApplyStart : null,
      onPlaceApplyEnd: typeof hooks.onPlaceApplyEnd === 'function' ? hooks.onPlaceApplyEnd : null,
      onPostalPlaceApplyStart: typeof hooks.onPostalPlaceApplyStart === 'function' ? hooks.onPostalPlaceApplyStart : null,
      onPostalPlaceApplyEnd: typeof hooks.onPostalPlaceApplyEnd === 'function' ? hooks.onPostalPlaceApplyEnd : null,
    };
  }

  function normalizePostalCode(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 6);
  }

  function normalizeStreetForCompare(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function streetsLikelyMatch(a, b) {
    var left = normalizeStreetForCompare(a);
    var right = normalizeStreetForCompare(b);
    if (!left || !right) return true;
    if (left === right) return true;
    if (left.indexOf(right) !== -1 || right.indexOf(left) !== -1) return true;
    return false;
  }

  function extractPostalFromAddressComponents(components) {
    if (!components || !components.length) return '';
    for (var i = 0; i < components.length; i++) {
      var comp = components[i];
      if (comp.types && comp.types.indexOf('postal_code') !== -1) {
        return normalizePostalCode(comp.long_name || comp.short_name || '');
      }
    }
    return '';
  }

  function extractStreetLineFromAddressComponents(components) {
    if (!components || !components.length) return '';
    var streetNumber = '';
    var route = '';
    for (var i = 0; i < components.length; i++) {
      var comp = components[i];
      if (!comp.types) continue;
      if (comp.types.indexOf('street_number') !== -1) {
        streetNumber = String(comp.long_name || comp.short_name || '').trim();
      }
      if (comp.types.indexOf('route') !== -1) {
        route = String(comp.long_name || comp.short_name || '').trim();
      }
    }
    if (streetNumber && route) return streetNumber + ' ' + route;
    return route || streetNumber || '';
  }

  function parseStreetFromFormattedAddress(formattedAddress, postal) {
    if (!formattedAddress) return '';
    var raw = String(formattedAddress).trim();
    raw = raw.replace(/,?\s*Singapore\s*\d{0,6}\s*$/i, '').trim();
    if (postal) {
      raw = raw.replace(new RegExp(',?\\s*' + postal + '\\s*$', 'i'), '').trim();
    }
    return raw;
  }

  function parseStreetFromInputValue(inputValue, postal) {
    var raw = String(inputValue || '').trim();
    if (!raw || /^\d{6}$/.test(raw)) return '';
    var parsed = parseStreetFromFormattedAddress(raw, postal);
    if (parsed) return parsed;
    if (raw.indexOf(',') !== -1) return raw.split(',')[0].trim();
    return raw;
  }

  function applyAddressComponents(place, streetInput, postalInput, unitInput, hooks) {
    if (!place || !place.address_components) return '';
    var filledPostal = '';
    for (var i = 0; i < place.address_components.length; i++) {
      var comp = place.address_components[i];
      var types = comp.types || [];
      if (types.indexOf('postal_code') !== -1 && postalInput) {
        postalInput.value = comp.long_name;
        filledPostal = normalizePostalCode(comp.long_name);
        if (hooks.onPostalFilled) hooks.onPostalFilled(comp.long_name);
      }
      if (types.indexOf('subpremise') !== -1 && unitInput && !unitInput.value) {
        unitInput.value = '#' + comp.long_name;
      }
    }
    if (streetInput) {
      var streetLine = extractStreetLineFromAddressComponents(place.address_components);
      if (streetLine) {
        streetInput.value = streetLine;
      } else if (place.formatted_address) {
        var parsedStreet = parseStreetFromFormattedAddress(place.formatted_address, filledPostal);
        if (parsedStreet) streetInput.value = parsedStreet;
      }
    }
    return filledPostal;
  }

  function shouldRunPostalGeocodeFallback(streetFromSelection, postal) {
    var code = normalizePostalCode(postal);
    if (code.length !== 6) return false;
    return !String(streetFromSelection || '').trim();
  }

  function applyPostalPlaceSelection(place, streetInput, postalInput, unitInput, hooks, callback) {
    callback = typeof callback === 'function' ? callback : function () {};
    var snapshotInput = postalInput ? String(postalInput.value || '').trim() : '';
    var filledPostal = applyAddressComponents(place, streetInput, postalInput, unitInput, hooks);
    var postal = filledPostal || normalizePostalCode(postalInput && postalInput.value);
    var streetFromSelection =
      extractStreetLineFromAddressComponents(place && place.address_components) ||
      parseStreetFromFormattedAddress(place && place.formatted_address, postal) ||
      parseStreetFromInputValue(snapshotInput, postal);

    if (streetInput && streetFromSelection) {
      streetInput.value = streetFromSelection;
    }

    if (!shouldRunPostalGeocodeFallback(streetFromSelection, postal)) {
      callback(filledPostal || postal);
      return;
    }

    geocodeAddress(snapshotInput || postal + ', Singapore', function (result) {
      if (streetInput && result && result.status === 'ok') {
        var geoStreet =
          result.streetLine ||
          parseStreetFromFormattedAddress(result.formattedAddress, result.postal || postal);
        if (geoStreet) streetInput.value = geoStreet;
        if (postalInput && result.postal) postalInput.value = result.postal;
      }
      callback(normalizePostalCode((postalInput && postalInput.value) || postal));
    });
  }

  function attachStreetAutocomplete(streetInput, postalInput, unitInput, hooks) {
    if (typeof google === 'undefined' || !google.maps || !google.maps.places) return false;

    var autocomplete = new google.maps.places.Autocomplete(streetInput, {
      componentRestrictions: { country: 'sg' },
      types: ['address'],
      fields: ['address_components', 'formatted_address'],
    });

    console.log(LOG + ' street autocomplete attached to', streetInput.id || streetInput.name);

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (!place) return;
      if (hooks.onPlaceApplyStart) hooks.onPlaceApplyStart();

      var filledPostal = '';
      try {
        var raw = streetInput.value || '';
        raw = raw.replace(/,?\s*Singapore\s*\d{0,6}\s*$/i, '').trim();
        if (raw) streetInput.value = raw;
        filledPostal = applyAddressComponents(place, streetInput, postalInput, unitInput, hooks);
      } finally {
        if (hooks.onPlaceApplyEnd) hooks.onPlaceApplyEnd(filledPostal);
      }
    });

    return true;
  }

  function attachPostalAutocomplete(postalInput, streetInput, unitInput, hooks) {
    if (typeof google === 'undefined' || !google.maps || !google.maps.places) return false;

    var autocomplete = new google.maps.places.Autocomplete(postalInput, {
      componentRestrictions: { country: 'sg' },
      types: ['address'],
      fields: ['address_components', 'formatted_address'],
    });

    console.log(LOG + ' postal autocomplete attached to', postalInput.id || postalInput.name);

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (!place) return;
      if (hooks.onPostalPlaceApplyStart) hooks.onPostalPlaceApplyStart();

      try {
        applyPostalPlaceSelection(place, streetInput, postalInput, unitInput, hooks, function (filledPostal) {
          if (hooks.onPostalPlaceApplyEnd) hooks.onPostalPlaceApplyEnd(filledPostal);
        });
      } catch (err) {
        console.warn(LOG + ' postal place apply failed', err);
        if (hooks.onPostalPlaceApplyEnd) hooks.onPostalPlaceApplyEnd('');
      }
    });

    return true;
  }

  function attachAll(streetInput, postalInput, unitInput, hooks) {
    var streetReady = attachStreetAutocomplete(streetInput, postalInput, unitInput, hooks);
    var postalReady = postalInput ? attachPostalAutocomplete(postalInput, streetInput, unitInput, hooks) : false;
    return streetReady || postalReady;
  }

  function init(streetInput, postalInput, unitInput, hooks) {
    if (!streetInput && !postalInput) return;
    hooks = normalizeHooks(hooks);

    window.gm_authFailure = function () {
      console.error(LOG + ' auth failed. Check API key, HTTP referrer restrictions, and enabled Maps/Places APIs.');
    };

    if (attachAll(streetInput, postalInput, unitInput, hooks)) return;

    var attempts = 0;
    var poll = setInterval(function () {
      if (attachAll(streetInput, postalInput, unitInput, hooks)) {
        clearInterval(poll);
        return;
      }
      attempts += 1;
      if (attempts > 20) {
        clearInterval(poll);
        console.warn(LOG + ' autocomplete did not initialize after ~10s. Script may be blocked or key restricted.');
      }
    }, 500);
  }

  function buildSavedAddressGeocodeQuery(address) {
    if (!address || typeof address !== 'object') return '';
    var parts = [];
    if (address.address1) parts.push(String(address.address1).trim());
    if (address.address2) parts.push(String(address.address2).trim());
    var zip = normalizePostalCode(address.zip);
    if (zip) parts.push(zip);
    parts.push('Singapore');
    return parts.filter(Boolean).join(', ');
  }

  function resolveGeocodePostalMismatch(enteredPostal, suggestedPostal) {
    var entered = normalizePostalCode(enteredPostal);
    var suggested = normalizePostalCode(suggestedPostal);
    if (entered.length !== 6 || suggested.length !== 6) {
      return { status: 'skipped', enteredPostal: entered, suggestedPostal: suggested };
    }
    if (entered === suggested) {
      return { status: 'match', enteredPostal: entered, suggestedPostal: suggested };
    }
    return { status: 'mismatch', enteredPostal: entered, suggestedPostal: suggested };
  }

  function whenGeocoderReady(done) {
    if (typeof done !== 'function') return;
    if (typeof google !== 'undefined' && google.maps && typeof google.maps.Geocoder === 'function') {
      done(true);
      return;
    }
    var attempts = 0;
    var poll = setInterval(function () {
      if (typeof google !== 'undefined' && google.maps && typeof google.maps.Geocoder === 'function') {
        clearInterval(poll);
        done(true);
        return;
      }
      attempts += 1;
      if (attempts > 20) {
        clearInterval(poll);
        done(false);
      }
    }, 500);
  }

  function geocodeAddress(query, callback) {
    callback = typeof callback === 'function' ? callback : function () {};
    if (!query) {
      callback({ status: 'skipped' });
      return;
    }
    whenGeocoderReady(function (ready) {
      if (!ready) {
        callback({ status: 'unavailable' });
        return;
      }
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        { address: query, componentRestrictions: { country: 'SG' } },
        function (results, status) {
          if (status !== 'OK' || !results || !results.length) {
            callback({ status: 'no_match' });
            return;
          }
          var best = results[0];
          callback({
            status: 'ok',
            postal: extractPostalFromAddressComponents(best.address_components),
            streetLine: extractStreetLineFromAddressComponents(best.address_components),
            formattedAddress: best.formatted_address || '',
          });
        }
      );
    });
  }

  function verifyStreetPostalConsistency(street, postal, callback) {
    callback = typeof callback === 'function' ? callback : function () {};
    var enteredPostal = normalizePostalCode(postal);
    var streetText = String(street || '').trim();
    if (enteredPostal.length !== 6 || !streetText) {
      callback({ status: 'skipped', enteredPostal: enteredPostal, suggestedPostal: '' });
      return;
    }
    geocodeAddress(streetText + ', Singapore', function (result) {
      if (!result || result.status !== 'ok') {
        callback({ status: result && result.status ? result.status : 'no_match', enteredPostal: enteredPostal, suggestedPostal: '' });
        return;
      }
      callback(resolveGeocodePostalMismatch(enteredPostal, result.postal));
    });
  }

  function verifySavedAddressPostalMatch(savedAddress, callback) {
    callback = typeof callback === 'function' ? callback : function () {};
    var enteredPostal = normalizePostalCode(savedAddress && savedAddress.zip);
    if (enteredPostal.length !== 6) {
      callback({ status: 'skipped', enteredPostal: enteredPostal, suggestedPostal: '' });
      return;
    }

    var query = buildSavedAddressGeocodeQuery(savedAddress);
    if (!query) {
      callback({ status: 'skipped', enteredPostal: enteredPostal, suggestedPostal: '' });
      return;
    }

    geocodeAddress(query, function (result) {
      if (!result || result.status !== 'ok') {
        callback({ status: result && result.status ? result.status : 'no_match', enteredPostal: enteredPostal, suggestedPostal: '' });
        return;
      }
      callback(resolveGeocodePostalMismatch(enteredPostal, result.postal));
    });
  }

  window.WF_LD_ADDRESS_AC = {
    loadScript: loadScript,
    init: init,
    buildSavedAddressGeocodeQuery: buildSavedAddressGeocodeQuery,
    resolveGeocodePostalMismatch: resolveGeocodePostalMismatch,
    verifySavedAddressPostalMatch: verifySavedAddressPostalMatch,
    verifyStreetPostalConsistency: verifyStreetPostalConsistency,
    streetsLikelyMatch: streetsLikelyMatch,
    normalizePostalCode: normalizePostalCode,
    extractStreetLineFromAddressComponents: extractStreetLineFromAddressComponents,
    parseStreetFromFormattedAddress: parseStreetFromFormattedAddress,
    parseStreetFromInputValue: parseStreetFromInputValue,
    shouldRunPostalGeocodeFallback: shouldRunPostalGeocodeFallback,
  };
})();
